import React, { FC, useCallback } from 'react';
import { SearchSelect, SearchSelectItem } from '@td-client-frontend/common';

const noSearchResultsMessage = 'No results found. Please try to adjust your search criteria.';

interface ActivitySearchSelect {
  onSearchChange: (value: string) => void;
  setSelected: (...args: any) => void;
  options: Array<SearchSelectItem>;
  name: string;
  label?: string;
  placeholder?: string;
  noSearchResultsMessage?: string;
  clearOnClose?: boolean;
  fieldWrapperWidthClass?: string;
  value: string;
}

export const ActivitySearchSelect: FC<ActivitySearchSelect> = ({
  setSelected,
  clearOnClose = true,
  fieldWrapperWidthClass,
  name,
  onSearchChange,
  value,
  label = '',
  ...props
}) => {
  const onSelect = useCallback(
    ({ value, label }: SearchSelectItem) => {
      onSearchChange(value);
      setSelected({ key: name, value, label });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSearchChange, setSelected]
  );

  const handleSetSearchValue = useCallback(
    (value: string) => {
      if (!clearOnClose) {
        setSelected({ key: name, value, label: '' });
      }
      onSearchChange(value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clearOnClose, setSelected, onSearchChange]
  );

  const onSearchSelectClear = useCallback(() => {
    // @ts-ignore
    onSelect({ key: name, value: '', label: '' });
    onSearchChange('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSelect]);

  return (
    <SearchSelect
      onSelect={onSelect}
      onSearchChange={handleSetSearchValue}
      value={value}
      required={false}
      isFiltered={false}
      efficientValueLength={0}
      fieldClasses="truncate"
      onClear={onSearchSelectClear}
      noSearchResultsMessage={noSearchResultsMessage}
      fieldWrapperWidthClass={fieldWrapperWidthClass || 'min-w-16'}
      clearOnClose={clearOnClose}
      name={name}
      label={label}
      {...props}
    />
  );
};

export default ActivitySearchSelect;
